<template>
  <div class="image-adv-selector">
    <div class="title-selector">
      <div class="title">右侧图片</div>
      <p class="tips">图片宽高比例约为1:4，建议分辨率为250x580</p>
    </div>
    <div class="body-selector">
      <image-link-editor
        v-model="$$FormData.picture"
        :limit="1"
        :multiple="false"
        :show-title="false"
        type="link"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'GoodsAndImagePictureSelector'
}
</script>

<style lang="scss" scoped>
.image-adv-selector {
  .title-selector {
    padding: 12px 16px;
    box-sizing: border-box;
    background-color: #ffffff;
    .title {
      color: #323233;
      font-size: 14px;
    }
    .tips {
      color: #969799;
      font-size: 12px;
      line-height: 18px;
      margin-top: 10px;
    }
  }
  .body-selector {
    padding: 12px 16px;
    background-color: #f7f8fa;
    overflow: hidden;
  }
}
</style>
